import MrpaDisable from '@/components/services/EgrnConfirm/Applicant/MrpaDisable/MrpaDisable.vue';
import ApplicantRightholder from '@/components/services/EgrnConfirm/ApplicantRightholder/ApplicantRightholder.vue';

import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType.vue';
import SubjectFillType from '@/components/services/common/SubjectFillType.vue';
import SelectApplicantRightholder from '@/components/services/EgrnConfirm/SelectApplicantRightholder.vue';
import ApplicantRightholderMrpa from '@/components/services/EgrnConfirm/ApplicantRightholder/ApplicantRightholderMrpa/index.vue';

import EstateObject from '@/components/services/EgrnConfirm/EstateObject/index.vue';
import Proof from '@/components/services/EgrnConfirm/Proof/index.vue';
import RefundDetails from '@/components/services/EgrnConfirm/RefundDetails.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const steps: unknown[] = [
  MrpaDisable,
  ApplicantRightholder,
  EstateObject,
  Proof,
  RefundDetails,
];

const mrpaSteps: unknown[] = [
  SelectSubjectFillType,
  SubjectFillType,
  SelectApplicantRightholder,
  ApplicantRightholderMrpa,
  EstateObject,
  Proof,
  RefundDetails,
];

export const egrnConfirmSteps: unknown[] = isMrpaEnable(
  StatementType.EGRN_CONFIRM
)
  ? mrpaSteps
  : steps;
